import React from "react";

const ApartmentDetails = ({ apartment, apartmentBlockFieldsOrder }) => {
    
    if (!apartment || !apartment.display_fields) {
        return null; // Return null if apartment or display_fields is not available
    }
  return (
    <div className="apartment-details d-flex"
      // style={{
      //   position: "absolute",
      //   bottom: "4.5rem",
      //   width: "100%",
      //   zIndex: 1000,
      // }}
      >
      {apartmentBlockFieldsOrder.map((detail) => (
                <div key={detail.title} className="detailsList pill">
                  {/* Use a div instead of li to avoid list styling */}
                  <div className="d-flex mb-1">
                    <span>
                      {detail.title}{" "}
                      {
                        apartment.display_fields.find(
                          (field) => field.field == detail.field
                        )?.value
                      }
                    </span>
                  </div>
                </div>
              ))}
    </div>
  );
};

export default ApartmentDetails;
